import type { TabPane } from 'components/DetailPanel/DetailPanel'
import { DetailPanel } from 'components/DetailPanel/DetailPanel'
import { IconDetails } from 'components/icons/IconDetails'
import { IconOverview } from 'components/icons/IconOverview'
import { IconSummary } from 'components/icons/IconSummary'
import { translate } from 'i18n/i18n'
import { usePreventPanelDetailsFromBeingOpen } from 'utils/usePreventPanelDetailsFromBeingOpen'
import { PanelDetails } from './PanelDetails/PanelDetails'

export const MAP_DETAILS_PANEL_WRAPPER_ID = 'map-details-panel'

export const MapDetailsPanel = () => {
  const preventPanelDetailsFromBeingOpen = usePreventPanelDetailsFromBeingOpen()

  const tabs: TabPane[] = [
    {
      key: 'OVERVIEW',
      label: translate.phrases.banyanApp('Overview'),
      icon: (
        <span css={{ fontSize: 32 }}>
          <IconOverview />
        </span>
      ),
    },
    ...(!preventPanelDetailsFromBeingOpen
      ? ([
          {
            key: 'GRAPHS',
            label: translate.phrases.banyanApp('Graphs'),
            icon: (
              <span css={{ fontSize: 30 }}>
                <IconDetails />
              </span>
            ),
          },
          {
            key: 'TABLES',
            label: translate.phrases.banyanApp('Tables'),
            icon: (
              <span css={{ fontSize: 32 }}>
                <IconSummary />
              </span>
            ),
          },
        ] as TabPane[])
      : []),
  ]

  return (
    <DetailPanel wrapperId={MAP_DETAILS_PANEL_WRAPPER_ID} tabs={tabs}>
      {({ width, height, isPanelExpanded }) => {
        return <PanelDetails panelWidth={width} panelHeight={height} isPanelExpanded={isPanelExpanded} />
      }}
    </DetailPanel>
  )
}
